module.exports = __webpack_public_path__ + "images/img-lpRYVEn.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/ranks/5.png
// module id = 1762
// module chunks = 0